import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const UserContext = createContext(null);

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('pump_user');
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      fetchUser(userData.id);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUser = async (userId) => {
    try {
      const response = await axios.get(`${API}/users/${userId}`);
      setUser(response.data);
      localStorage.setItem('pump_user', JSON.stringify(response.data));
    } catch (error) {
      console.error('Error fetching user:', error);
      localStorage.removeItem('pump_user');
    } finally {
      setLoading(false);
    }
  };

  const createUser = async (username, walletAddress = null) => {
    try {
      const response = await axios.post(`${API}/users`, {
        username,
        wallet_address: walletAddress
      });
      setUser(response.data);
      localStorage.setItem('pump_user', JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  };

  const updateProgress = async (courseId, updates) => {
    if (!user) return;
    try {
      const response = await axios.put(`${API}/progress`, {
        user_id: user.id,
        course_id: courseId,
        ...updates
      });
      setUser(response.data);
      localStorage.setItem('pump_user', JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error('Error updating progress:', error);
    }
  };

  const refreshUser = async () => {
    if (user?.id) {
      await fetchUser(user.id);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('pump_user');
  };

  return (
    <UserContext.Provider value={{
      user,
      loading,
      createUser,
      updateProgress,
      refreshUser,
      logout
    }}>
      {children}
    </UserContext.Provider>
  );
};
